<vwui-modal-header>
  <div class="w-full flex items-center">
    <h3>Project referentie toevoegen</h3>
  </div>
</vwui-modal-header>

<vwui-modal-body class="project-modal-body">
  <vwui-search [formControl]="searchControl" placeholder="Zoeken op projectnaam, plaats of projectnummer"></vwui-search>
  @if ((projects$ | async); as content) {
    <div class="project-list">
      @for (project of content; track project) {
        <div class="project-box" (click)="projectControl.setValue(project)">
          <div class="project-box__content border rounded transition duration-300 ease-in-out cursor-pointer"
            [ngClass]="{'border-neutral-3': project.id !== projectControl.value?.id, 'border-primary': project.id === projectControl.value?.id}">
            <div>
              <h4 class="font-medium">{{project.name}}</h4>
              <span class="project-box__content__info">
                {{project.city}} &bull; {{project.code}}
              </span>
            </div>
            <vwui-radio id="radio-{{project.code}}" class="project-box__content__radio" name="project"
              [checked]="project.id === projectControl.value?.id"
            [value]="project"></vwui-radio>
          </div>
        </div>
      }
      <div class="project-list__fade-bottom"></div>
    </div>
  }
</vwui-modal-body>

<vwui-modal-footer>
  <vwui-button class="is-light" (click)="modalRef.close()">Annuleren</vwui-button>
  <vwui-button class="is-primary" (click)="createReference()" [disabled]="projectControl.invalid">Toevoegen</vwui-button>
</vwui-modal-footer>
